<template>
  <v-btn v-bind="btnProps" @click="sendMessageDialog = true">
    傳送訊息給患者

    <v-dialog v-if="sendMessageDialog" v-model="sendMessageDialog" :max-width="sendValidation.error ? 420 : 500">
      <v-card v-if="initLoading" :loading="initLoading">
        <v-card-title/>
      </v-card>
      <template v-else>
        <v-card v-if="sendValidation.isValid" class="pb-4">
          <v-btn
            fab
            icon
            absolute
            width="48"
            height="48"
            style="top: 0; right: 0; overflow: hidden;"
            @click="sendMessageDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-title>編輯傳送簡訊</v-card-title>
          <v-divider/>
          <v-card-text class="pt-4">
            <div class="mb-2 text-body-1">
              <span class="red-6--text font-weight-bold">{{ kycPrefix }}</span>
            </div>
            <v-textarea
              v-model="editableContent"
              placeholder="請輸入簡訊內容"
              outlined
              no-resize
              :error="showError"
              :error-messages="errorMessage"
              :messages="countText"
              @input="handleInput"
            />
            <div class="red--text text-caption mt-4">
              <div class="font-weight-medium">
                重要說明：因應政府反詐政策規定，簡訊必須在內文清楚標示發訊者身分。因此系統已於簡訊開頭加上「{{ kycPrefix }}」，已計入字數且無法刪除，否則可能會被判定為詐騙簡訊而導致發送失敗。              </div>
              <br>
              內文 1～70 字為 1 點，71～140 字為 2 點，141～210 字為 3 點 …依此類推<br>
              ・備註一：輸入的字數與實際發送的字數可能有些微差異，將會依照實際發送的字數來扣點<br>
              ・備註二：近期政府推動反詐騙宣導，若內文涉及敏感字眼，可能會有被阻擋發送之風險，若有遇到發送不成功的情況請再洽詢 <a :href="$enum.DENTCO_CS_LINE" target="_blank">牙醫小幫手客服</a><br>
              ・備註三：承上則，每封客製化簡訊將會經由電信企業審核，無詐騙疑慮才能送出，審核時間長度不一，無法立即送達，敬請耐心等候。<br>
              ・備註四：請勿在訊息內放入網址連結，否則可能會被判定為詐騙簡訊而導致發送失敗。
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" width="100" @click="confirmMessage">確定內容</v-btn>
            <v-btn outlined width="100" color="grey-5" @click="sendMessageDialog = false">取消</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else class="px-8 px-md-10 py-4">
          <v-card-title class="justify-center">操作失敗</v-card-title>
          <v-card-text class="text-center red-6--text font-weight-medium text-pre-line">
            {{ validationMessage }}
          </v-card-text>
          <v-card-actions>
            <div class="d-flex flex-column" style="width: 100%; gap: 20px;">
              <template v-if="sendValidation.error === 'NO_BALANCE'">
                <v-btn
                  color="red-6"
                  block
                  dark
                  :href="$enum.DENTCO_CS_LINE"
                  target="_blank"
                  @click="closeMessage"
                >聯繫客服儲值
                </v-btn>
                <v-btn color="grey-4" dark block @click="closeMessage">我知道了，關閉視窗</v-btn>
              </template>
              <template v-if="sendValidation.error === 'SMS_NOT_ENABLED'">
                <v-btn
                  color="red-6"
                  block
                  dark
                  :href="$enum.DENTCO_CS_LINE"
                  target="_blank"
                  @click="closeMessage"
                >聯繫客服
                </v-btn>
                <v-btn color="grey-4" dark block @click="closeMessage">我知道了，關閉視窗</v-btn>
              </template>
              <template v-if="sendValidation.error === 'INVALID_PHONE_FORMAT'">
                <v-btn color="grey-4" dark block @click="closeMessage">我知道了，關閉視窗</v-btn>
              </template>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="messageConfirmDialog" max-width="420" persistent>
      <v-card :loading="messageLoading" class="px-8 px-md-10 py-4">
        <v-card-title>將傳送以下訊息給{{ patient.patientName }}</v-card-title>
        <v-card-text>
          <div class="text-pre-line overflow-y-auto" v-text="messageContent" style="max-height: 400px;"/>
          <div class="mt-4 red-6--text font-weight-medium">
            目前剩餘簡訊點數約：<span class="text-decoration-underline">{{ quota }}</span> 點<br>
            本次預計使用：<span class="text-decoration-underline">{{ useQuota }}</span> 點<br>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" width="100" :disabled="messageLoading" @click="sendMessage">確認傳送</v-btn>
          <v-btn outlined width="100" color="grey-5" :disabled="messageLoading" @click="messageConfirmDialog = false">
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resultDialog" max-width="420" persistent>
      <v-card class="px-8 px-md-10 py-4">
        <v-card-title class="justify-center">{{ resultTitle }}</v-card-title>
        <v-card-text v-if="resultStatus !== 'success'">
          錯誤原因： {{ messageResult }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="resultStatus === 'success'"
            color="grey-4"
            dark
            block
            @click="closeMessage"
          >我知道了，關閉視窗</v-btn>
          <v-btn v-else color="grey-4" dark block @click="resultDialog = false">再試一次</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
import { getSmsQuotaAPI, getSmsStatus, sendSmsMessageAPI } from "@/api";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "SendSmsMessageV2",

  props: {
    patient: {
      type: Object,
      required: true
    },
    btnProps: {
      type: Object,
      required: false,
      default: () => ({
        small: true,
        block: true,
        color: "tiffany-7",
        class: "white--text"
      })
    }
  },

  data() {
    return {
      initLoading: false,
      sendMessageDialog: false,
      messageConfirmDialog: false,
      messageContent: '',
      editableContent: '',
      messageLoading: false,
      showError: false,
      errorMessage: '',

      SmsCharLimit: 70,  // 簡訊每 70 字，算一封錢

      resultStatus: 'success',
      resultDialog: false,
      resultTitle: '',
      messageResult: null,

      sendValidation: {
        isValid: false,
        error: null,
      },

      quota: 0
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
      'smsStatusLoaded',
      'smsStatus',
      'clinicUser',
      'userInfo'
    ]),
    kycPrefix() {
      if (!this.userInfo) return ''

      if (this.clinicUser) {
        // 診所登入：取得診所名稱
        return `${this.userInfo.name}通知：`
      } else {
        // 醫師登入：取得 (alias || name) + title
        const doctorName = this.userInfo.alias || this.userInfo.name
        const title = this.userInfo.title || ''
        return `${doctorName}${title}通知：`
      }
    },
    countText() {
      if (this.messageContent)
        return `已編輯 ${this.messageContent.length} 字 / 預計使用 ${Math.ceil(this.messageContent.length / 70)} 點`
    },
    canSendMessage() {
      return this.sendValidation.isValid
    },
    validationMessage() {
      const messages = {
        NO_BALANCE: '簡訊點數不足。',
        SMS_NOT_ENABLED: '尚未開啟簡訊功能，\n請先聯繫客服開通與完成儲值。',
        INVALID_PHONE_FORMAT: '患者資料沒有手機號碼或格式錯誤，\n請重新確認手機為09開頭共10碼數字。'
      }
      return messages[this.sendValidation.error] || ''
    },
    useQuota() {
      return Math.ceil(this.messageContent?.length / this.SmsCharLimit)
    }
  },

  watch: {
    async sendMessageDialog(v) {
      if (v) {
        this.initLoading = true
        try {
          await this.checkSmsStatus()
          await this.getChannelQuota()
          await this.checkSendEligibility()
        } catch (e) {
          console.error(e)
          this.$notify.error(this.$t('GENERAL.oops'))
          this.closeMessage()
        } finally {
          this.initLoading = false
        }
      } else {
        this.reset()
      }
    },
  },

  methods: {
    ...mapMutations({
      setSmsStatus: 'setSmsStatus'
    }),
    async checkSmsStatus() {
      if (!this.smsStatusLoaded) {
        const res = await getSmsStatus(this.axiosParamData)
        this.setSmsStatus(res.data.sms_status)
      }
    },
    async getChannelQuota() {
      const res = await getSmsQuotaAPI(this.axiosParamData)
      this.quota = Number(res.data.quota)
    },
    handleInput(inputValue) {
      // 清除錯誤提示
      this.showError = false
      this.errorMessage = ''

      // 將可編輯內容與前綴組合後儲存
      this.editableContent = inputValue || ''
      this.messageContent = this.kycPrefix + this.editableContent
    },
    confirmMessage() {
      // 如果只有前綴沒有實際內容，顯示錯誤提示
      if (!this.editableContent || !this.editableContent.trim()) {
        this.showError = true
        this.errorMessage = '請輸入訊息內容'
        return
      }
      this.showError = false
      this.errorMessage = ''
      this.messageConfirmDialog = true
    },
    sendMessage() {
      this.messageLoading = true
      const data = {
        ...this.axiosParamData,
        content: this.messageContent,
      }

      if (this.patient.patientCode) {
        data.patient_code = this.patient.patientCode
      } else {
        data.phone = this.patient.patientPhone
      }

      sendSmsMessageAPI(data).then(() => {
        this.resultStatus = 'success'
        this.resultTitle = '發送成功'
        this.messageConfirmDialog = false
      }).catch(e => {
        this.resultStatus = 'error'
        this.resultTitle = '發送失敗'
        this.messageResult = e.response?.data?.messages || '發生未知錯誤，請再試一次'
      }).finally(() => {
        this.resultDialog = true
        this.messageLoading = false
      })
    },
    closeMessage() {
      this.messageConfirmDialog = false
      this.sendMessageDialog = false
      this.resultDialog = false
      this.reset()
    },
    reset() {
      this.messageContent = this.$options.data().messageContent
      this.editableContent = this.$options.data().editableContent
      this.showError = this.$options.data().showError
      this.errorMessage = this.$options.data().errorMessage
      this.resultStatus = this.$options.data().resultStatus
      this.resultTitle = this.$options.data().resultTitle
      this.messageResult = this.$options.data().messageResult
      this.sendValidation = this.$options.data().sendValidation
      this.quota = this.$options.data().quota
    },
    checkSendEligibility() {
      let error = null

      // 1. 檢查簡訊功能是否已開通
      if (!this.smsStatus) {
        error = 'SMS_NOT_ENABLED'
      }

      // 2. 檢查病患手機格式（09 開頭、10 碼）
      else if (!/^09\d{8}$/.test(this.patient?.patientPhone || '')) {
        error = 'INVALID_PHONE_FORMAT'
      }

      // 3. 檢查點數是否足夠
      else if (this.quota < 1) {
        error = 'NO_BALANCE'
      }

      this.sendValidation = {
        isValid: !error,
        error
      }
    }
  }
}
</script>

<style scoped>

</style>
